import { queryOptions } from "@tanstack/react-query";
import { GET_USER_INF_FOR_WEB, LST_PBIMG } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import { useAuthStore } from "~/stores/useAuthStore";
import type { PublicImage, UserProfileResponse } from "./types";

// サーバ仕様: user_id = 自分（ログイン中ユーザー）、req_user_id = 対象ユーザー
export const userProfileQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.user.profile(userId),
    queryFn: () =>
      apiClient<UserProfileResponse>(GET_USER_INF_FOR_WEB, {
        user_id: useAuthStore.getState().userId,
        req_user_id: userId,
      }),
  });

// lst_pbimg は req_user_id に「対象ユーザーID」を渡す iOS 仕様に合わせる
export const publicImagesQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.user.publicImages(userId),
    queryFn: () =>
      apiClient<PublicImage[]>(LST_PBIMG, {
        req_user_id: userId,
        skip: 0,
        take: 50,
      }),
  });
